module.exports = __webpack_public_path__ + "img/meatify_logo.e1c032ef.svg";